/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.timer-content[_ngcontent-%COMP%]{width:100%;padding:10px 0;margin:0}.timer-content[_ngcontent-%COMP%]   .timer-label[_ngcontent-%COMP%]{color:#7a7a7a}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvbmV3LXdhdmUtLW53LWFkZXNhLXVpLXBpcGVsaW5lL3NvdXJjZS9ub2RlX21vZHVsZXMvQG53L3VpLXdhdGNobGlzdC9jb21wb25lbnRzL2NvbXBvbmVudHMtdjEvY291bnRkb3duLXRpbWVyLXYxL2NvdW50ZG93bi10aW1lci12MS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL25ldy13YXZlLS1udy1hZGVzYS11aS1waXBlbGluZS9zb3VyY2Uvbm9kZV9tb2R1bGVzL0Budy91aS13YXRjaGxpc3QvY29tcG9uZW50cy9jb21wb25lbnRzLXYxL2NvdW50ZG93bi10aW1lci12MS9jb3VudGRvd24tdGltZXItdjEuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/main/angular/$$_gendir/node_modules/@nw/ui-watchlist/components/components-v1/countdown-timer-v1/countdown-timer-v1.component.scss.shim.ngstyle.ts